(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[716],{

/***/ 4783:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefits",
      function () {
        return __webpack_require__(1282);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1292:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/hero-banner-bg.dc0c0f4f.jpeg","height":575,"width":1400,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAZEAADAQEBAAAAAAAAAAAAAAAAARECEiH/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhEDEQA/AJfrT4t9SUAAMLX/2Q==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 2555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6180);
/* harmony import */ var _public_assets_hero_banner_bg_jpeg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1292);
/* harmony import */ var _hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4493);





function PageTitle(param) {
    var topComponent = param.topComponent, title = param.title, description = param.description, className = param.className;
    var useHighContrast = (0,_hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_3__/* .useAccessibilitySettings */ .C)().useHighContrast;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m)("pt-12 pb-12 lg:pt-20 lg:pb-20", useHighContrast ? "bg-contrast-yellow text-black" : "", className),
        style: {
            backgroundImage: useHighContrast ? "unset" : "url(".concat(_public_assets_hero_banner_bg_jpeg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src, ")"),
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center top",
            backgroundSize: "cover"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container flex flex-col items-center",
            children: [
                topComponent,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m)("text-4xl font-medium text-center", useHighContrast ? "text-inherit" : "text-white", description ? "mb-8" : null, topComponent ? "mt-4" : null),
                    children: title
                }),
                description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m)("text-xl font-light text-center max-w-[760px]", useHighContrast ? "text-inherit" : "text-white"),
                    children: description
                }) : null
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);


/***/ }),

/***/ 3618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_SEO; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./config/site.config.ts
var siteConfig = Object.freeze({
    title: "GoodFoodTalks",
    description: "GoodFoodTalks",
    twitterCreator: "@GoodFoodTalks"
});

;// CONCATENATED MODULE: ./components/utils/SEO.tsx



function SEO(param) {
    var pageTitle = param.title, description = param.description, socialImageSrc = param.socialImageSrc;
    var siteTitle = siteConfig.title, siteDescription = siteConfig.description, twitterCreator = siteConfig.twitterCreator;
    var title = "".concat(pageTitle, " | ").concat(siteTitle);
    var metaDescription = description !== null && description !== void 0 ? description : siteDescription;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:creator",
                content: twitterCreator
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:description",
                content: metaDescription
            }),
            socialImageSrc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: socialImageSrc
            }) : null
        ]
    });
}
/* harmony default export */ var utils_SEO = (SEO);


/***/ }),

/***/ 1282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ benefits; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(9583);
// EXTERNAL MODULE: ./node_modules/react-icons/im/index.esm.js
var im_index_esm = __webpack_require__(3990);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/lib/tw-merge.mjs + 11 modules
var tw_merge = __webpack_require__(6180);
// EXTERNAL MODULE: ./hooks/useAccessibilitySettings.tsx
var useAccessibilitySettings = __webpack_require__(4493);
// EXTERNAL MODULE: ./components/Layout/index.ts + 7 modules
var Layout = __webpack_require__(1284);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/sections/CallToAction.tsx





function CallToAction(param) {
    var title = param.title, buttonHref = param.buttonHref, buttonLabel = param.buttonLabel, className = param.className;
    var useHighContrast = (0,useAccessibilitySettings/* useAccessibilitySettings */.C)().useHighContrast;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,tw_merge/* twMerge */.m)("pt-12 pb-12 lg:pt-20 lg:pb-20", useHighContrast ? "bg-contrast-yellow text-black" : "bg-[#fbfbee]", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container flex flex-col items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (0,tw_merge/* twMerge */.m)("text-2xl lg:text-3xl text-center mb-10"),
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    prefetch: false,
                    href: buttonHref,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (0,tw_merge/* twMerge */.m)("btn btn-xl", useHighContrast ? "btn-contrast-yellow" : "btn-primary"),
                        children: buttonLabel
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var sections_CallToAction = (CallToAction);

;// CONCATENATED MODULE: ./components/sections/Features.tsx




function Features(param) {
    var items = param.items, className = param.className;
    var useHighContrast = (0,useAccessibilitySettings/* useAccessibilitySettings */.C)().useHighContrast;
    if (!Array.isArray(items) || items.length < 1) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,tw_merge/* twMerge */.m)("pt-12 pb-12 lg:pt-20 lg:pb-20", useHighContrast ? "bg-contrast-yellow text-black" : "bg-[#f6f4df]", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1 lg:grid-cols-3 gap-20",
                children: items.map(function(param) {
                    var icon = param.icon, title = param.title, description = param.description;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,tw_merge/* twMerge */.m)("h-[112px] w-[112px] rounded-full flex items-center justify-center", useHighContrast ? "bg-inherit" : "bg-white"),
                                children: icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-center mt-6 text-xl font-medium",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-light mt-4",
                                children: description
                            })
                        ]
                    }, title);
                })
            })
        })
    });
}
/* harmony default export */ var sections_Features = (Features);

// EXTERNAL MODULE: ./components/sections/PageTitle.tsx
var PageTitle = __webpack_require__(2555);
// EXTERNAL MODULE: ./components/utils/SEO.tsx + 1 modules
var SEO = __webpack_require__(3618);
;// CONCATENATED MODULE: ./pages/benefits.tsx











var Benefits = function() {
    var useHighContrast = (0,useAccessibilitySettings/* useAccessibilitySettings */.C)().useHighContrast;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Benefits",
                description: "Benefits to restaurant owners"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                topComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(im_index_esm/* ImSpoonKnife */.VcR, {
                    className: (0,tw_merge/* twMerge */.m)("h-20 w-20", useHighContrast ? "text-black" : "text-primary-600"),
                    "aria-hidden": "true"
                }),
                title: "Benefits to Restaurant Owners"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (0,tw_merge/* twMerge */.m)("pt-12 pb-12 lg:pt-20 lg:pb-20", useHighContrast ? "bg-contrast-yellow text-black" : "bg-[#fbfbee]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (0,tw_merge/* twMerge */.m)("text-2xl lg:text-3xl text-center mb-10"),
                            children: "Ever wondered how visually impaired people read a menu?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "font-light space-y-6 max-w-[950px] mx-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "The truth is, it’s a huge problem!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "There are more than two million people with a visual impairment in the UK. Their conditions range from those who are totally blind through to people whose vision can’t be corrected by even the strongest of glasses."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "As a business how do you accommodate what equates to one in every 30 people? To their credit, some restaurants offer Braille and special large print versions of their menus but did you know that fewer than 1% of people with visual impairment can read Braille?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "And what happens if you change the menu more than a couple of times a year?"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center mt-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                prefetch: false,
                                href: "/contact-us",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: (0,tw_merge/* twMerge */.m)("btn btn-xl inline-flex", useHighContrast ? "btn-contrast-yellow" : "btn-primary"),
                                    children: [
                                        "Get in touch",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaChevronRight */.Dli, {
                                            className: "h-5 w-5 ml-4",
                                            "aria-hidden": "true"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_Features, {
                items: [
                    {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaUsers */.I$, {
                            className: (0,tw_merge/* twMerge */.m)("h-14 w-14", useHighContrast ? "text-black" : "text-primary-600"),
                            "aria-hidden": "true"
                        }),
                        title: "Increased Customer Base",
                        description: "Make your restaurant a fully inclusive dining experience for anybody with a visual impairment. There are more than 2 million people in the UK who either can't, or struggle to read menus. Having your menu on Good Food Talks provides you with a cost effective, hastle-free and instant solution."
                    },
                    {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaCogs */.rU2, {
                            className: (0,tw_merge/* twMerge */.m)("h-14 w-14", useHighContrast ? "text-black" : "text-primary-600"),
                            "aria-hidden": "true"
                        }),
                        title: "No additional effort",
                        description: "With our managed menu service, making your menus accessible doesn't have to be time consuming. It's a Cost-effective way to add to your bottom line"
                    },
                    {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaUniversalAccess */.vfn, {
                            className: (0,tw_merge/* twMerge */.m)("h-14 w-14", useHighContrast ? "text-black" : "text-primary-600"),
                            "aria-hidden": "true"
                        }),
                        title: "Be socially responsible",
                        description: "Every business wants their company to be socially responsible, giving all customers an equal opportunity to enjoy their products and services."
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_CallToAction, {
                title: "Do you want to feature your menu on GoodFoodTalks?",
                buttonHref: "/contact-us",
                buttonLabel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Get started",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaChevronRight */.Dli, {
                            className: "h-5 w-5 ml-4",
                            "aria-hidden": "true"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var benefits = (Benefits);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [445,609,314,284,774,888,179], function() { return __webpack_exec__(4783); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);